import request from './request'

/**
 * @author 孟祥龙
 * @Desc TODO 诗人相关请求
 * @date 2021/5/9 10:03
 * @return
 */

// 按照id获取作者信息
export const GetPoetById = (params) => request.get("/poet/getPoetById",{params});